import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import QueryParamsProxy from '../../utils/queryParamProxy';
import Screens from '..';
import InboxMessagesProvider from '../../components/InboxMessagesProvider';
import audio from '../../utils/audio';
import { setPiggyLowBetTooltipCount } from '../PiggyBank/utils/helpers';
var SessionExpired = /*#__PURE__*/function (_Component) {
  function SessionExpired(props) {
    var _this;
    _classCallCheck(this, SessionExpired);
    _this = _callSuper(this, SessionExpired, [props]);
    _this.expireSessionHandler = function () {
      audio.pauseMusic();
      _this.props.clearState();
      _this.props.clearApiQueryState();
      InboxMessagesProvider.resetInbox();
      setPiggyLowBetTooltipCount(0);
      QueryParamsProxy.setQueryParams({
        m: undefined
      });
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Start);
    };
    if (_this.props.ftueStep) {
      _this.props.setOnboardingFtueStep(_this.props.ftueStep);
    }
    return _this;
  }
  _inherits(SessionExpired, _Component);
  return _createClass(SessionExpired, [{
    key: "render",
    value: function render() {
      return this.props.render({
        expireSessionHandler: this.expireSessionHandler
      });
    }
  }]);
}(Component);
export { SessionExpired as default };